module.exports = __webpack_public_path__ + "img/img35.e6f9229b.png";